import { render, staticRenderFns } from "./ModalMileage.vue?vue&type=template&id=4b4abe1e"
import script from "./ModalMileage.vue?vue&type=script&lang=js"
export * from "./ModalMileage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports